import { HttpContext, HttpContextToken } from '@angular/common/http';

export const IS_API_REQUEST = new HttpContextToken<boolean>(() => false);

export const apiRequestContext = () => new HttpContext().set(IS_API_REQUEST, true);
